const r = (e) => e.reduce(
  (t, o) => t + (o.total_price ? parseFloat(o.total_price) * o.amount : 0),
  0
), p = (e) => e.reduce((t, o) => t + parseFloat(o.amount), 0), P = (e, t) => {
  const o = e.reduce((c, a) => {
    const l = parseFloat(a.totalPrice), n = r(a.optionalExtras), s = l + n, u = !a.cityTaxIncluded && a.cityTaxes && parseFloat(a.cityTaxes) || 0, i = r(a.mandatoryExtras);
    return c + i + u + s;
  }, 0);
  return t ? o + parseFloat(t) : o;
}, x = ({
  cartItems: e,
  giftCards: t,
  insurancePrice: o
}) => {
  let c = 0;
  return e != null && e.length ? c = P(e, o) : t != null && t.length && (c = p(t)), c.toFixed(2);
};
export {
  x as calculateTotalPrice
};
